import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Grid, Button } from '@material-ui/core';

const ScenarioSidebar = ({ scenarios, selectedScenario, onSelectScenario }) => {
    return (
        <Box>
            <Grid container spacing={3}>
                {scenarios.map((scenario) => {
                    const isSelected = selectedScenario && selectedScenario.id === scenario.id;
                    return (
                        <Grid item xs={12} sm={6} md={4} key={scenario.id}>
                            <Card
                                elevation={0}
                                style={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    border: isSelected ? '1.5px solid #1e88e5' : '1px solid #e2e8f0',
                                    borderRadius: '16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    backgroundColor: isSelected ? '#f8faff' : '#fff',
                                    boxShadow: isSelected ? '0 10px 25px -5px rgba(30, 136, 229, 0.1)' : 'none',
                                }}
                                onMouseEnter={(e) => {
                                    if (!isSelected) {
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = '0 12px 20px -10px rgba(0,0,0,0.08)';
                                        e.currentTarget.style.borderColor = '#cbd5e1';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isSelected) {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = '#e2e8f0';
                                    }
                                }}
                                onClick={() => onSelectScenario(scenario)}
                            >
                                <CardContent style={{ flexGrow: 1, padding: '24px', display: 'flex', flexDirection: 'column' }}>
                                    <Box mb={3}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            width={48}
                                            height={48}
                                            borderRadius="12px"
                                            bgcolor={isSelected ? '#1e88e5' : '#f1f5f9'}
                                            color={isSelected ? '#fff' : '#1e88e5'}
                                            mb={2}
                                            style={{ transition: 'all 0.2s ease' }}
                                        >
                                            <svg
                                                width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor"
                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                            >
                                                <path d={scenario.icon || "M12 2L2 22h20L12 2z"} />
                                            </svg>
                                        </Box>
                                        <Typography variant="h6" style={{ fontWeight: 700, fontSize: '1.1rem', color: '#1a365d' }}>
                                            {scenario.name}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: '24px', lineHeight: 1.6, fontSize: '0.875rem' }}>
                                        {scenario.description || 'Run AI analysis for this scenario.'}
                                    </Typography>

                                    <Box mt="auto" display="flex" justifyContent="space-between" alignItems="center" pt={2}>
                                        <Typography
                                            variant="button"
                                            style={{
                                                textTransform: 'none',
                                                fontWeight: 700,
                                                color: '#1e88e5',
                                                fontSize: '0.8rem',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                        >
                                            Launch AI Session <span style={{ marginLeft: '6px', fontSize: '16px' }}>→</span>
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default ScenarioSidebar;
